module.exports = __webpack_public_path__ + "img/電気回路_2_3_2.67cd304e.png";